import { TariffGroupAttributeTypeEnum } from '@src/core/buyerApiClient/api';

import type { SelectedProductAttribute } from '@src/domains/products/features/product-booking/types/attribute';

export const getSelectedLanguageValue = (attributes: SelectedProductAttribute[]): string | null =>
  attributes.find((attribute) => attribute.type === TariffGroupAttributeTypeEnum.Language)?.value ?? null;
